import React from 'react';

import { Message, Icon, Tab } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import useStyleRuleConfigurations from 'components/modules/style-rules/hooks/useStyleRuleConfigurations/useStyleRuleConfigurations';
import { DismissibleMessage, ErrorBoundary } from 'components/modules/utils/components';
import { DEFAULT_ERROR_MESSAGE } from 'libs/errors/constants';

import { ThemeTemplatesTab, ActiveStyleRulesTab, SettingsTab } from './components';
import useStyleRules from '../../modules/style-rules/hooks/useStyleRules';

import './StyleRulesPage.scss';

export default function StyleRulesPage() {
  const { loading: loadingRules } = useStyleRules({ forceFetch: true });
  const { styleRuleConfigurations, loading: loadingRulesConfiguration } =
    useStyleRuleConfigurations({ forceFetch: true });

  if (loadingRules || loadingRulesConfiguration) {
    return (
      <Message icon>
        <Icon name="circle notched" loading />
        <Message.Content>
          <Message.Header>Loading...</Message.Header>
          We are getting your style rules for you.
        </Message.Content>
      </Message>
    );
  }

  const displaySettingsTab = !_isEmpty(styleRuleConfigurations);
  const displayThemeTemplatesTab = !_isEmpty(styleRuleConfigurations);

  function createTabPane(menuItem, keyName, Component) {
    return {
      menuItem,
      render: () => (
        <Tab.Pane attached={false} key={keyName}>
          <Component />
        </Tab.Pane>
      ),
    };
  }

  let panes = [createTabPane('Active Styles', 'active-styles', ActiveStyleRulesTab)];

  if (displaySettingsTab) {
    panes = [createTabPane('Settings', 'settings', SettingsTab), ...panes];
  }

  if (displayThemeTemplatesTab) {
    panes = [...panes, createTabPane('Theme Templates', 'theme-templates', ThemeTemplatesTab)];
  }

  return (
    <ErrorBoundary
      fallback={<DismissibleMessage initialVisible content={DEFAULT_ERROR_MESSAGE} error />}
    >
      <div className="style-rules-page">
        <Tab className="main-tab" menu={{ secondary: true, pointing: true }} panes={panes} />
      </div>
    </ErrorBoundary>
  );
}
